import React from 'react';

const About = () => {
    return <div className="about-container">About</div>;
};

export default About;
